module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "aeris-theme-host"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d73b244a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aeris-theme/aeris-wordpress-theme.vue
// module id = 177
// module chunks = 0